document.addEventListener('DOMContentLoaded', function () {
    let header = document.getElementsByTagName('header')[0];
    let pagesContent = document.getElementById('contenu');
    const wpAdminBar = document.getElementById('wpadminbar');

    if(header) {
        const headerOffset = header.offsetTop;

        function handleScroll() {
            let headerHeight = header.scrollHeight-2;
            const scrollPosition = window.scrollY || document.documentElement.scrollTop;

            if(wpAdminBar) {
                headerHeight = headerHeight-32;
            }

            if(scrollPosition > headerOffset) {
                header.classList.add('position-fixed');
                header.classList.add('t-0');
                pagesContent.style.marginTop = headerHeight+'px';
            } else {
                header.classList.remove('position-fixed');
                header.classList.remove('t-0');
                pagesContent.style.marginTop = 0;
            }
        }

        window.addEventListener('scroll', handleScroll);
    }
});
